var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RenderInformation',_vm._b({attrs:{"content":_vm.data.settings.text},on:{"edit-content":_vm.editContent}},'RenderInformation',{ title:_vm.data.name, body:_vm.data.body, editor: _vm.editor, theme: _vm.theme },false))}
var staticRenderFns = []

export { render, staticRenderFns }